<template>
    <div class="pageManager-m">
        <div class="jobMain">
            <div class="manager-rig">
                <div v-if="!sonFlag">
                    <div class="manager-rt">
                        <div class="manager-rtle">招聘发布</div>
                        <div class="manager-rtr">
                            <el-radio-group v-model="queryData.talentType" size="small" @change="onTalentTypeChange">
                                <el-radio-button :label="0">优培人才</el-radio-button>
                                <el-radio-button :label="1">技术人才</el-radio-button>
                                <el-radio-button :label="2">操作人才</el-radio-button>
                            </el-radio-group>
                            <el-input
                                class="manager-search-input"
                                placeholder="搜索专业"
                                prefix-icon="el-icon-search"
                                v-model="queryData.name"
                                clearable
                                @keyup.enter.native="searchFun">
                            </el-input>
                            <el-button type="primary" size="small" @click="searchFun">查询</el-button>
                        </div>
                    </div>
                    <div class="exam-m1">
                        <el-row :gutter="24">
                            <el-col :span="8" v-for="(item, index) in summaryBoxList" :key="index">
                                <div class="exam-m1-box">
                                    <div class="exam-m1-icon" :class="item.css"><i :class="item.icon"></i></div>
                                    <div class="exam-m1-box-tle">{{ item.label }}</div>
                                    <div class="exam-m1-box-num" :class="summaryBoxCss[index]">{{ item.num }}</div>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                    <div class="manager-jobM">
                        <!-- 优培人才 -->
                        <table class="manager-job-table" v-if="roleFlag===1 && queryData.talentType === 0">
                            <tr>
                                <th style="border-top-left-radius: 10px;">专业类别</th>
                                <th>专业名称</th>
                                <th width="80">报名数</th>
                                <th width="90">已审核数</th>
                                <th width="90">待审核数</th>
                                <th width="80" style="border-top-right-radius: 10px;">操作</th>
                            </tr>
                            <tr v-for="(item,index) in jobData.records" :key="'yp'+index">
                                <td>{{ item.majorCategory }}</td>
                                <td>{{ item.majorName }}</td>
                                <td>{{ item.applicationCount != null ? item.applicationCount : 0 }}</td>
                                <td>{{ item.reviewedCount != null ? item.reviewedCount : 0 }}</td>
                                <td>{{ item.pendingCount != null ? item.pendingCount : 0 }}</td>
                                <td><el-button type="text" @click="jobView(item.id,index)">查看</el-button></td>
                            </tr>
                        </table>
                        <!-- 技术人才 -->
                        <table class="manager-job-table" v-if="roleFlag===1 && queryData.talentType === 1">
                            <tr>
                                <th style="border-top-left-radius: 10px;">本科专业名称</th>
                                <th>本科专业代码</th>
                                <th width="80">报名数</th>
                                <th width="90">已审核数</th>
                                <th width="90">待审核数</th>
                                <th width="80" style="border-top-right-radius: 10px;">操作</th>
                            </tr>
                            <tr v-for="(item,index) in jobData.records" :key="'js'+index">
                                <td>{{ item.undergraduateMajorName }}</td>
                                <td>{{ item.undergraduateMajorCode }}</td>
                                <td>{{ item.applicationCount != null ? item.applicationCount : 0 }}</td>
                                <td>{{ item.reviewedCount != null ? item.reviewedCount : 0 }}</td>
                                <td>{{ item.pendingCount != null ? item.pendingCount : 0 }}</td>
                                <td><el-button type="text" @click="jobView(item.id,index)">查看</el-button></td>
                            </tr>
                        </table>
                        <!-- 操作人才 -->
                        <table class="manager-job-table" v-if="roleFlag===1 && queryData.talentType === 2">
                            <tr>
                                <th style="border-top-left-radius: 10px;">工作类别</th>
                                <th>专业类别</th>
                                <th width="80">报名数</th>
                                <th width="90">已审核数</th>
                                <th width="90">待审核数</th>
                                <th width="80" style="border-top-right-radius: 10px;">操作</th>
                            </tr>
                            <tr v-for="(item,index) in jobData.records" :key="'cz'+index">
                                <td>{{ workTypeLabel(item.workType) }}</td>
                                <td>{{ item.majorCategory }}</td>
                                <td>{{ item.applicationCount != null ? item.applicationCount : 0 }}</td>
                                <td>{{ item.reviewedCount != null ? item.reviewedCount : 0 }}</td>
                                <td>{{ item.pendingCount != null ? item.pendingCount : 0 }}</td>
                                <td><el-button type="text" @click="jobView(item.id,index)">查看</el-button></td>
                            </tr>
                        </table>
                        <div v-if="jobData.total > 0" style="padding: 20px;">
                            <el-pagination
                                background
                                :current-page="jobData.current"
                                layout="total, prev, pager, next, sizes"
                                @current-change="changePage"
                                @size-change="changeSize"
                                :page-sizes="[10, 20, 50, 100, 200]"
                                :page-size="10"
                                :total="jobData.total">
                            </el-pagination>
                        </div>
                    </div>
                </div>
                <div v-if="sonFlag">
                    <div class="sonTle"><span class="backLink" @click="backList"><i class="el-icon-back"></i> 返回列表</span></div>
                    <div class="job-sonM">
                        <div class="job-sonM-t">
                            <el-tag type="danger" size="small">{{ talentTypeLabel }}</el-tag>
                        </div>
                        <div class="job-sonM-subt" v-if="queryData.talentType === 0">
                            <span>专业类别：<B>{{ curJob.majorCategory || '—' }}</B></span>
                            <span class="job-son-line">|</span>
                            <span>专业名称：<B>{{ curJob.majorName || '—' }}</B></span>
                        </div>
                        <div class="job-sonM-subt" v-else-if="queryData.talentType === 1">
                            <span>本科专业名称：<B>{{ curJob.undergraduateMajorName || '—' }}</B></span>
                            <span class="job-son-line">|</span>
                            <span>本科专业代码：<B>{{ curJob.undergraduateMajorCode || '—' }}</B></span>
                        </div>
                        <div class="job-sonM-subt" v-else-if="queryData.talentType === 2">
                            <span>工作类别：<B>{{ workTypeLabel(curJob.workType) || '—' }}</B></span>
                            <span class="job-son-line">|</span>
                            <span>专业类别：<B>{{ curJob.majorCategory || '—' }}</B></span>
                        </div>
                        <div class="job-sonM-extra" v-if="curJob.educationRequire || curJob.graduationYearsRequirement">
                            <el-tag v-if="curJob.educationRequire" type="info" size="mini">学历要求：{{ curJob.educationRequire }}</el-tag>
                            <span v-if="curJob.educationRequire && curJob.graduationYearsRequirement" class="job-son-line">|</span>
                            <span v-if="curJob.graduationYearsRequirement">毕业年限：{{ curJob.graduationYearsRequirement }}</span>
                        </div>
                    </div>
                    <div class="job-sonM1">
                        <div class="job-son-tab">
                            <ul>
                                <li v-for="(item,index) in tabsTle" :class="tabFlag===index ? 'active' : ''" :key="index" @click="changeTabs(index)">{{ item }}</li>
                            </ul>
                        </div>
                        <div class="manager-jobM">
                            <table class="manager-job-table">
                                <tr>
                                    <th>姓名</th>
                                    <th>性别</th>
                                    <th>毕业院校</th>
                                    <th>专业</th>
                                    <th>最高学历</th>
                                    <th>批注</th>
                                    <th>状态</th>
                                    <th>操作</th>
                                </tr>
                                <tr v-for="(item,index) in personData" :key="index">
                                    <td>{{item.name}}</td>
                                    <td>{{gender[item.gender]}}</td>
                                    <td>{{item.graduatedInstitution}}</td>
                                    <td>{{item.major}}</td>
                                    <td>{{item.education}}</td>
                                    <td class="manager-comment-cell">
                                        <span
                                            v-if="getCommentPreview(item)"
                                            class="comment-preview"
                                            :title="getCommentPreview(item, false)"
                                            @click="openCommentDialog(item)">
                                            {{ getCommentPreview(item) }}
                                        </span>
                                        <span v-else class="comment-empty">—</span>
                                        <el-tag
                                            v-if="getUserComments(item).length"
                                            size="mini"
                                            type="info"
                                            class="comment-count-tag">
                                            {{ getUserComments(item).length }}
                                        </el-tag>
                                    </td>
                                    <td>
                                        <el-tag
                                            v-if="isReviewedStatus(item.approvalStatus)"
                                            :type="sonStatus[item.approvalStatus].color"
                                            size="mini"
                                            class="status-reviewed-tag"
                                            @click.native="openApprovalLog(item.id)">
                                            {{ reviewedStatusLabel(item.approvalStatus) }}
                                        </el-tag>
                                        <el-tag v-else :type="sonStatus[item.approvalStatus].color" size="mini">
                                            {{ sonStatus[item.approvalStatus].label }}
                                        </el-tag>
                                    </td>
                                    <td class="manager-op-cell">
                                        <button v-if="item.approvalStatus === 2" class="bmCheck" @click="bmView(item.id, 1)">审核</button>
                                        <el-button type="text" @click="bmView(item.id, 0)">查看</el-button>
                                        <el-button type="text" @click="openApprovalLog(item.id)">审核日志</el-button>
                                        <el-button type="text" @click="openCommentDialog(item)">批注</el-button>
                                        <el-button
                                            v-if="canShowDeleteCandidateBtn"
                                            type="text"
                                            class="comment-del-btn"
                                            @click="openDeleteCandidateDialog(item)"
                                        >删除考生信息</el-button>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog
            title="删除考生信息"
            :visible.sync="deleteCandidateDialogVisible"
            width="560px"
            top="8vh"
            @closed="onDeleteCandidateDialogClosed">
            <div v-if="deleteCandidateTarget">
                <div class="delete-candidate-tip">此操作将删除该考生在本系统内的全部信息（报名表、附件、家庭信息、考试记录及用户账号等），删除后可重新报名。请仔细核对以下信息：</div>
                <div class="delete-candidate-info">
                    <div><span class="label">考生姓名：</span>{{ deleteCandidateTarget.name || '—' }}</div>
                    <div><span class="label">身份证号码：</span>{{ deleteCandidateTarget.idCardNumber || deleteCandidateTarget.id_card_number || '—' }}</div>
                    <div><span class="label">手机号：</span>{{ deleteCandidateTarget.phone || '—' }}</div>
                </div>
                <div class="delete-candidate-confirm-label">请输入确认文案（需完全一致）：</div>
                <div class="delete-candidate-confirm-text">{{ deleteCandidateConfirmExpected }}</div>
                <el-input
                    v-model="deleteCandidateConfirmInput"
                    placeholder="请完整输入上方确认文案"
                    maxlength="100"
                />
                <div class="delete-candidate-confirm-label" style="margin-top: 16px;">删除理由：</div>
                <el-input
                    type="textarea"
                    :autosize="{ minRows: 3, maxRows: 6 }"
                    placeholder="请填写删除理由"
                    v-model="deleteCandidateReason"
                    maxlength="1000"
                    show-word-limit
                />
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="deleteCandidateDialogVisible = false">取消</el-button>
                <el-button
                    type="danger"
                    :loading="deleteCandidateSubmitting"
                    :disabled="!canSubmitDeleteCandidate"
                    @click="submitDeleteCandidate">
                    确认删除
                </el-button>
            </span>
        </el-dialog>
        <el-dialog
            title="查看报名信息"
            :visible.sync="viewDialogVisible"
            width="92%"
            top="2vh"
            custom-class="manager-view-dialog"
            @closed="onViewDialogClosed">
            <application-form-preview
                v-if="viewDialogVisible && viewApplicationId"
                :application-id="viewApplicationId"
            />
        </el-dialog>
        <el-dialog
            title="审核日志"
            :visible.sync="logDialogVisible"
            width="640px"
            top="8vh"
            @closed="onLogDialogClosed">
            <div v-loading="logLoading">
                <div v-if="!logLoading && approvalLogs.length === 0" class="log-empty">暂无审核记录</div>
                <div v-for="(log, idx) in approvalLogs" :key="idx" class="approval-log-item">
                    <div class="approval-log-head">
                        <span class="approval-log-status">{{ approvalLogStatusLabel(log.approvalStatus) }}</span>
                        <span class="approval-log-time">{{ formatLogTime(log.approvalTime) }}</span>
                    </div>
                    <div class="approval-log-row"><span class="label">审核人：</span>{{ log.approvalByName || '—' }}</div>
                    <div class="approval-log-row"><span class="label">审核意见：</span>{{ log.approvalComment || '—' }}</div>
                </div>
            </div>
        </el-dialog>
        <el-dialog
            title="审核报名信息"
            :visible.sync="dialogVisible"
            width="50%"
            top="5vh"
            :before-close="dialogClose">
            <div>
                <div class="bm-check" v-if="bmViewFlag === 1">
                    <div class="bm-check-t"><i class="el-icon-document blue"></i> 审核处理</div>
                    <div class="bm-check-m">
                        <div>审核备注 / 反馈意见</div>
                        <div><el-input type="textarea" :autosize="{ minRows: 3, maxRows: 4}" placeholder="请输入审批意见" v-model="bmCheckObj.comment"></el-input></div>
                        <div style="padding: 15px 0;">
                            <el-row :gutter="20">
                                <el-col :span="8">
                                    <el-button type="success" style="width: 100%;" @click="bmCheck(3)">审核通过</el-button>
                                </el-col>
                                <el-col :span="8">
                                    <el-button type="warning" style="width: 100%;" @click="bmCheck(1)">补充资料</el-button>
                                </el-col>
                                <el-col :span="8">
                                    <el-button type="danger" style="width: 100%;" @click="bmCheck(4)">审核不通过</el-button>
                                </el-col>
                            </el-row>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
        <el-dialog
            title="人员批注"
            :visible.sync="commentDialogVisible"
            width="640px"
            top="8vh"
            @closed="onCommentDialogClosed">
            <div v-loading="commentLoading">
                <div class="comment-dialog-head">
                    <span>姓名：<b>{{ commentUserName || '—' }}</b></span>
                </div>
                <div class="comment-editor">
                    <div class="comment-editor-label">{{ commentEditId ? '编辑批注' : '新增批注' }}</div>
                    <el-input
                        type="textarea"
                        :autosize="{ minRows: 3, maxRows: 6 }"
                        placeholder="请输入批注内容"
                        v-model="commentFormContent"
                        maxlength="2000"
                        show-word-limit
                    />
                    <div class="comment-editor-actions">
                        <el-button v-if="commentEditId" size="small" @click="resetCommentForm">取消编辑</el-button>
                        <el-button type="primary" size="small" :loading="commentSaving" @click="saveComment">
                            {{ commentEditId ? '保存修改' : '添加批注' }}
                        </el-button>
                    </div>
                </div>
                <div class="comment-list-title">历史批注</div>
                <div v-if="!commentLoading && commentList.length === 0" class="log-empty">暂无批注</div>
                <div v-for="comment in commentList" :key="comment.id" class="user-comment-item">
                    <div class="user-comment-head">
                        <span class="user-comment-author">{{ pickCommentByName(comment) }}</span>
                        <span class="user-comment-time">{{ formatLogTime(pickCommentTime(comment)) }}</span>
                    </div>
                    <div class="user-comment-content">{{ pickCommentContent(comment) }}</div>
                    <div class="user-comment-actions">
                        <el-button type="text" size="mini" @click="startEditComment(comment)">编辑</el-button>
                        <el-button type="text" size="mini" class="comment-del-btn" @click="deleteComment(comment)">删除</el-button>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>

import Cookies from "js-cookie";
import axios from "axios";
import ApplicationFormPreview from './ApplicationFormPreview.vue';

const DELETE_CANDIDATE_ALLOWED_PHONES = ['10000000001', '10000000000', '13453585585'];

export default {
    name: 'PageManagerJob',
    components: { ApplicationFormPreview },
    data() {
        return {
            queryData: {
                current: 1,
                size: 10,
                talentType: 0,
                name: ''
            },
            gender: {0: '女', 1: '男'},
            roleFlag: 1,
            workTypeMap: {0: '煤矿井下一线', 1: '化工生产一线'},
            sonFlag: 0,
            jobData: {},
            curJob: {},
            personData: [],
            spStatus: {
                1: {label: '待补充资料', color: '#99A1AF'},
                2: {label: '待审批', color: '#E6A23C'},
                3: {label: '审批通过', color: '#67C23A'},
                4: {label: '审批不通过', color: '#E7000B'}
            },
            jobStatus: {1: {label: '招聘中', color: 'success'}, 2: {label: '招聘完成', color: 'primary'}, 3: {label: '招聘取消', color: 'danger'}},
            sonStatus: {0: {label: '待签名', color: 'info'}, 1: {label: '待补充资料', color: 'warning'}, 2: {label: '待审批', color: 'primary'}, 3: {label: '审批通过', color: 'success'}, 4: {label: '审批不通过', color: 'danger'}},
            tabsTle: ['全部', '待补充资料', '待审批', '审批通过', '审批不通过'],
            tabFlag: 0,
            jobQuery: {
                approvalStatus: '',
                positionId: null
            },
            personQuery: {},
            dialogVisible: false,
            viewDialogVisible: false,
            viewApplicationId: null,
            bmCheckObj: {
                id: null,
                flag: 3,
                comment: ''
            },
            bmViewFlag: 0,
            logDialogVisible: false,
            logLoading: false,
            approvalLogs: [],
            logApplicationId: null,
            approvalLogStatusMap: {
                1: '需补充资料',
                2: '审批中',
                3: '审核通过',
                4: '审核不通过',
            },
            summaryBoxList: [
                { label: '总报名人数', num: 0, icon: 'el-icon-user', css: 'exam-m1-icon-blue' },
                { label: '已审核人数', num: 0, icon: 'el-icon-circle-check', css: 'exam-m1-icon-green' },
                { label: '待审核人数', num: 0, icon: 'el-icon-time', css: 'exam-m1-icon-yellow' },
            ],
            summaryBoxCss: { 0: '', 1: 'green', 2: 'yellow' },
            commentDialogVisible: false,
            commentLoading: false,
            commentSaving: false,
            commentUserId: null,
            commentUserName: '',
            commentList: [],
            commentFormContent: '',
            commentEditId: null,
            deleteCandidateDialogVisible: false,
            deleteCandidateTarget: null,
            deleteCandidateConfirmInput: '',
            deleteCandidateReason: '',
            deleteCandidateSubmitting: false,
            currentUserPhone: '',
        }
    },
    computed: {
        canShowDeleteCandidateBtn: function () {
            const phone = (this.currentUserPhone || '').trim();
            return DELETE_CANDIDATE_ALLOWED_PHONES.indexOf(phone) !== -1;
        },
        talentTypeLabel: function () {
            const map = {0: '优培人才', 1: '技术人才', 2: '操作人才'};
            return map[this.queryData.talentType] != null ? map[this.queryData.talentType] : '';
        },
        deleteCandidateConfirmExpected: function () {
            const name = this.deleteCandidateTarget && this.deleteCandidateTarget.name ? this.deleteCandidateTarget.name : '';
            return '我已确认删除"' + name + '"信息';
        },
        canSubmitDeleteCandidate: function () {
            const reason = (this.deleteCandidateReason || '').trim();
            return this.deleteCandidateConfirmInput === this.deleteCandidateConfirmExpected && reason.length > 0;
        },
    },
    mounted() {
        document.title = '潞安招聘-招聘发布';
        this.loadCurrentUserPhone();
        this.loadSummaryStats();
        this.getJobList();
    },
    methods: {
        loadCurrentUserPhone: function () {
            if (!Cookies.get('reqToKen')) {
                this.currentUserPhone = '';
                return;
            }
            axios.get('/zhaopinapi/users/info', {
                headers: { Authorization: Cookies.get('reqToKen') },
            }).then((res) => {
                const _d = res.data;
                if (_d.success && _d.data) {
                    this.currentUserPhone = (_d.data.phone || '').trim();
                }
            }).catch((error) => {
                console.log(error);
            });
        },
        searchFun: function () {
            this.loadSummaryStats();
            this.getJobList(1);
        },
        onTalentTypeChange: function () {
            this.queryData.name = '';
            this.loadSummaryStats();
            this.getJobList(1);
        },
        loadSummaryStats: function () {
            if (!Cookies.get('reqToKen')) {
                return;
            }
            axios.get('/zhaopinapi/job-applications/statistics/summary', {
                headers: { Authorization: Cookies.get('reqToKen') },
                params: { talentType: this.queryData.talentType },
            }).then((res) => {
                const _d = res.data;
                if (_d.success && _d.data) {
                    this.summaryBoxList[0].num = _d.data.totalApplications != null ? _d.data.totalApplications : 0;
                    this.summaryBoxList[1].num = _d.data.reviewedApplications != null ? _d.data.reviewedApplications : 0;
                    this.summaryBoxList[2].num = _d.data.pendingApplications != null ? _d.data.pendingApplications : 0;
                } else {
                    this.summaryBoxList[0].num = 0;
                    this.summaryBoxList[1].num = 0;
                    this.summaryBoxList[2].num = 0;
                }
            }).catch((error) => {
                console.log(error);
            });
        },
        workTypeLabel: function (workType) {
            if (workType === null || workType === undefined || workType === '') return '';
            return this.workTypeMap[workType] != null ? this.workTypeMap[workType] : workType;
        },
        buildListParams: function () {
            const params = {
                current: this.queryData.current,
                size: this.queryData.size,
                talentType: this.queryData.talentType,
                isDeleted: 0,
            };
            const keyword = (this.queryData.name || '').trim();
            if (keyword) {
                if (this.queryData.talentType === 1) {
                    params.undergraduateMajorName = keyword;
                } else if (this.queryData.talentType === 2) {
                    params.majorCategory = keyword;
                } else {
                    params.majorName = keyword;
                }
            }
            return params;
        },
        backList: function () {
            this.sonFlag = 0;
            this.loadSummaryStats();
            this.getJobList(1);
        },
        changeTabs: function (n) {
            this.tabFlag = n;
            this.jobQuery.approvalStatus = n===0 ? "" : n;
            this.jobView();
        },
        jobView: function (id, n) {
            // 注意：n 为 0 时 (id && n) 为 false，必须用显式判断索引
            if (id != null && n != null && n !== undefined && this.jobData.records && this.jobData.records[n]) {
                this.curJob = this.jobData.records[n];
            }
            this.jobQuery.positionId = id != null ? id : this.jobQuery.positionId;
            this.sonFlag = 1;
            if(Cookies.get('reqToKen')) {
                axios.get('/zhaopinapi/job-applications/all', {
                    headers: {'Authorization': Cookies.get('reqToKen')},
                    params: this.jobQuery
                }).then((res) => {
                    let _d = res.data;
                    if (_d.success) {
                        const list = Array.isArray(_d.data) ? _d.data : [];
                        const statusFilter = this.jobQuery.approvalStatus;
                        this.personData = list.filter((item) => {
                            const s = item.approvalStatus != null ? item.approvalStatus : item.approval_status;
                            if (statusFilter === '' || statusFilter == null) {
                                return Number(s) !== 0;
                            }
                            return true;
                        });
                        // console.log(this.personData)
                    }
                }).catch((error) => {
                    // this.$message.error(error);
                    console.log(error)
                })
            }
        },
        bmView: function (id, flag) {
            this.bmViewFlag = flag;
            this.bmCheckObj.id = id;
            if (flag === 1) {
                this.viewDialogVisible = false;
                this.dialogVisible = true;
            } else {
                this.dialogVisible = false;
                this.viewApplicationId = id;
                this.viewDialogVisible = true;
            }
        },
        onViewDialogClosed: function () {
            this.viewApplicationId = null;
        },
        isReviewedStatus: function (status) {
            return status === 1 || status === 3 || status === 4;
        },
        reviewedStatusLabel: function (status) {
            const meta = this.sonStatus[status];
            const detail = meta ? meta.label : ('状态' + status);
            return '已审核-' + detail;
        },
        approvalLogStatusLabel: function (status) {
            return this.approvalLogStatusMap[status] || ('状态' + status);
        },
        formatLogTime: function (time) {
            if (!time) return '—';
            return String(time).replace('T', ' ').substring(0, 19);
        },
        pickUserId: function (item) {
            if (!item) return null;
            return item.userId != null ? item.userId : item.user_id;
        },
        getUserComments: function (item) {
            if (!item) return [];
            const list = item.userComments || item.user_comments;
            return Array.isArray(list) ? list : [];
        },
        getCommentPreview: function (item, truncate) {
            if (truncate === undefined) truncate = true;
            const list = this.getUserComments(item);
            if (!list.length) return '';
            const latest = list[0];
            const text = this.pickCommentContent(latest);
            if (!text) return '';
            if (!truncate || text.length <= 24) return text;
            return text.substring(0, 24) + '…';
        },
        pickCommentContent: function (comment) {
            if (!comment) return '';
            return comment.commentContent || comment.comment_content || '';
        },
        pickCommentByName: function (comment) {
            if (!comment) return '—';
            return comment.commentByName || comment.comment_by_name || '—';
        },
        pickCommentTime: function (comment) {
            if (!comment) return '';
            return comment.commentTime || comment.comment_time || '';
        },
        pickCommentId: function (comment) {
            if (!comment) return null;
            return comment.id;
        },
        syncPersonComments: function (userId, comments) {
            if (!userId || !Array.isArray(this.personData)) return;
            this.personData = this.personData.map((row) => {
                if (this.pickUserId(row) === userId) {
                    return Object.assign({}, row, { userComments: comments, user_comments: comments });
                }
                return row;
            });
        },
        openCommentDialog: function (item) {
            const userId = this.pickUserId(item);
            if (!userId) {
                this.$message.warning('无法获取人员信息');
                return;
            }
            this.commentUserId = userId;
            this.commentUserName = item.name || '';
            this.commentDialogVisible = true;
            this.resetCommentForm();
            this.loadUserComments(userId);
        },
        onCommentDialogClosed: function () {
            this.commentUserId = null;
            this.commentUserName = '';
            this.commentList = [];
            this.resetCommentForm();
        },
        resetCommentForm: function () {
            this.commentEditId = null;
            this.commentFormContent = '';
        },
        startEditComment: function (comment) {
            this.commentEditId = this.pickCommentId(comment);
            this.commentFormContent = this.pickCommentContent(comment);
        },
        loadUserComments: function (userId) {
            if (!userId || !Cookies.get('reqToKen')) {
                return;
            }
            this.commentLoading = true;
            axios.get('/zhaopinapi/user-comment/user/' + userId, {
                headers: { Authorization: Cookies.get('reqToKen') },
            }).then((res) => {
                const _d = res.data;
                if (_d.success) {
                    this.commentList = _d.data || [];
                    this.syncPersonComments(userId, this.commentList);
                } else {
                    this.commentList = [];
                    this.$message.error(_d.message || '加载批注失败');
                }
            }).catch((error) => {
                console.log(error);
                this.commentList = [];
                this.$message.error('加载批注失败');
            }).finally(() => {
                this.commentLoading = false;
            });
        },
        saveComment: function () {
            const content = (this.commentFormContent || '').trim();
            if (!content) {
                this.$message.warning('请输入批注内容');
                return;
            }
            if (!this.commentUserId || !Cookies.get('reqToKen')) {
                return;
            }
            this.commentSaving = true;
            const headers = { Authorization: Cookies.get('reqToKen') };
            const request = this.commentEditId
                ? axios.put('/zhaopinapi/user-comment', {
                    id: this.commentEditId,
                    userId: this.commentUserId,
                    commentContent: content,
                }, { headers })
                : axios.post('/zhaopinapi/user-comment', {
                    userId: this.commentUserId,
                    commentContent: content,
                }, { headers });
            request.then((res) => {
                const _d = res.data;
                if (_d.success) {
                    this.$message.success(this.commentEditId ? '批注已更新' : '批注已添加');
                    this.resetCommentForm();
                    this.loadUserComments(this.commentUserId);
                } else {
                    this.$message.error(_d.message || '保存批注失败');
                }
            }).catch((error) => {
                console.log(error);
                const msg = (error.response && error.response.data && error.response.data.message)
                    ? error.response.data.message
                    : '保存批注失败';
                this.$message.error(msg);
            }).finally(() => {
                this.commentSaving = false;
            });
        },
        deleteComment: function (comment) {
            const id = this.pickCommentId(comment);
            if (!id || !Cookies.get('reqToKen')) {
                return;
            }
            this.$confirm('确定删除该批注吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                axios.delete('/zhaopinapi/user-comment/' + id, {
                    headers: { Authorization: Cookies.get('reqToKen') },
                }).then((res) => {
                    const _d = res.data;
                    if (_d.success) {
                        this.$message.success('批注已删除');
                        if (this.commentEditId === id) {
                            this.resetCommentForm();
                        }
                        this.loadUserComments(this.commentUserId);
                    } else {
                        this.$message.error(_d.message || '删除批注失败');
                    }
                }).catch((error) => {
                    console.log(error);
                    this.$message.error('删除批注失败');
                });
            }).catch(() => {});
        },
        openDeleteCandidateDialog: function (item) {
            if (!this.canShowDeleteCandidateBtn) {
                return;
            }
            this.deleteCandidateTarget = item;
            this.deleteCandidateConfirmInput = '';
            this.deleteCandidateReason = '';
            this.deleteCandidateDialogVisible = true;
        },
        onDeleteCandidateDialogClosed: function () {
            this.deleteCandidateTarget = null;
            this.deleteCandidateConfirmInput = '';
            this.deleteCandidateReason = '';
            this.deleteCandidateSubmitting = false;
        },
        submitDeleteCandidate: function () {
            if (!this.canSubmitDeleteCandidate) {
                this.$message.warning('请完整输入确认文案并填写删除理由');
                return;
            }
            if (!this.deleteCandidateTarget || !this.deleteCandidateTarget.id || !Cookies.get('reqToKen')) {
                return;
            }
            this.deleteCandidateSubmitting = true;
            axios.post('/zhaopinapi/job-applications/' + this.deleteCandidateTarget.id + '/purge-candidate', {
                confirmText: this.deleteCandidateConfirmInput,
                deleteReason: (this.deleteCandidateReason || '').trim(),
            }, {
                headers: { Authorization: Cookies.get('reqToKen') },
            }).then((res) => {
                const _d = res.data;
                if (_d && (_d.success === true || _d.code === 200)) {
                    this.$message.success('考生信息已删除');
                    this.deleteCandidateDialogVisible = false;
                    this.loadSummaryStats();
                    this.jobView();
                } else {
                    this.$message.error(_d.message || '删除失败');
                }
            }).catch((error) => {
                console.log(error);
                const data = error.response && error.response.data;
                const msg = (data && (data.message || data.msg))
                    || (error.response && error.response.status === 403
                        ? '无权访问或接口未部署，请确认已登录管理员账号并重启后端服务'
                        : null)
                    || '删除失败，请稍后重试';
                this.$message.error(msg);
            }).finally(() => {
                this.deleteCandidateSubmitting = false;
            });
        },
        openApprovalLog: function (applicationId) {
            this.logApplicationId = applicationId;
            this.logDialogVisible = true;
            this.loadApprovalLogs(applicationId);
        },
        onLogDialogClosed: function () {
            this.logApplicationId = null;
            this.approvalLogs = [];
        },
        loadApprovalLogs: function (applicationId) {
            if (!applicationId || !Cookies.get('reqToKen')) {
                return;
            }
            this.logLoading = true;
            axios.get('/zhaopinapi/application-approval-log/application/' + applicationId, {
                headers: { Authorization: Cookies.get('reqToKen') },
            }).then((res) => {
                const _d = res.data;
                if (_d.success) {
                    this.approvalLogs = _d.data || [];
                } else {
                    this.approvalLogs = [];
                    this.$message.error(_d.message || '加载审核日志失败');
                }
            }).catch((error) => {
                console.log(error);
                this.approvalLogs = [];
                this.$message.error('加载审核日志失败');
            }).finally(() => {
                this.logLoading = false;
            });
        },
        dialogClose: function () {
            this.dialogVisible = false;
        },
        getJobList: function (pn,ps) {
            this.queryData.current = pn ? pn : this.queryData.current;
            this.queryData.size = ps ? ps : this.queryData.size;
            if(Cookies.get('reqToKen')) {
                axios.get('/zhaopinapi/recruit-position-info/find-page', {
                    headers: {'Authorization': Cookies.get('reqToKen')},
                    params: this.buildListParams()
                }).then((res) => {
                    let _d = res.data;
                    if (_d.success) {
                        this.jobData = _d.data || { records: [], total: 0, current: 1, size: 10 };
                    } else {
                        this.$message.error(_d.message || '查询失败');
                        this.jobData = { records: [], total: 0, current: 1, size: this.queryData.size };
                    }
                }).catch((error) => {
                    console.log(error);
                    this.$message.error('查询失败');
                })
            }
        },
        changePage: function (currentPage) {
            this.queryData.current = currentPage;
            this.getJobList(currentPage, this.queryData.size);
        },
        changeSize: function (val) {
            this.queryData.size = val;
            this.getJobList(1, this.queryData.size);
        },
        bmCheck: function (flag) {
            this.bmCheckObj.flag = flag;
            if(Cookies.get('reqToKen')) {
                axios.get('/zhaopinapi/job-applications/approval', {
                    headers: {'Authorization': Cookies.get('reqToKen')},
                    params: this.bmCheckObj
                }).then((res) => {
                    let _d = res.data;
                    if (_d.success) {
                        this.$message.success('审核成功');
                        this.dialogVisible = false;
                        this.loadSummaryStats();
                        this.getJobList();
                        this.jobView();
                    } else {
                        this.$message.error(_d.message || '审核失败');
                    }
                }).catch((error) => {
                    // this.$message.error(error);
                    console.log(error)
                })
            }
        }
    }
}
</script>

<style scoped>
    .pageManager-m{padding: 30px 0;}
    .jobMain{width: 80%; max-width: 1400px; margin: 0 auto;}
    @media (max-width: 1400px) and (min-width: 1300px) {
        .jobMain{width: 90%;  margin: 0 auto;}
    }
    @media (max-width: 1300px) {
        .jobMain{width: 100%; min-width: 1150px;}
    }
    .manager-rig{}
    .manager-rt{min-height: 42px; padding-bottom: 18px;}
    .manager-rtle{font-size: 24px; line-height: 40px; float: left; font-weight: bold;}
    .manager-rtr{
        float: right;
        height: 40px;
        display: flex;
        align-items: center;
        flex-wrap: nowrap;
        gap: 12px;
    }
    .manager-rtr .el-radio-group{flex-shrink: 0;}
    .manager-search-input{width: 220px; flex-shrink: 0;}
    .manager-search-input >>> .el-input__inner{height: 32px; line-height: 32px;}
    .exam-m1{padding: 0 0 20px 0;}
    .exam-m1-box{background: #FFF; border: 1px solid #e9e9eb; box-shadow: 0 3px 3px 0 #e9e9eb; padding: 16px; height: 50px; border-radius: 10px; position: relative;}
    .exam-m1-icon{padding: 8px; width: 20px; height: 20px; font-size: 20px; line-height: 20px; text-align: center; border-radius: 8px; margin-top: 7px; position: absolute; right: 20px; top: 15px;}
    .exam-m1-icon-blue{background: #ecf5ff; color: #409eff;}
    .exam-m1-icon-yellow{background: #fdf6ec; color: #e6a23c;}
    .exam-m1-icon-green{background: #f0f9eb; color: #67c23a;}
    .exam-m1-box-tle{font-size: 12px; line-height: 18px; color: #99A1AF;}
    .exam-m1-box-num{font-size: 24px; line-height: 32px; color: #000; font-weight: bold;}
    .exam-m1-box-num.green{color: #67c23a;}
    .exam-m1-box-num.yellow{color: #e6a23c;}
    .manager-jobM{border-radius: 10px; border: 1px solid #F3F4F6; background: #fff;}
    .manager-job-table{width: 100%; border-collapse: collapse; border-spacing: 0; border-radius: 10px;}
    .manager-job-table td{padding: 5px 20px; line-height: 20px !important; background: #fff; border-bottom: 1px solid #f9fafb;}
    .manager-job-table th{padding: 15px 20px; line-height: 20px; background: #f9fafb; border-bottom: 1px solid #f9fafb; text-align: left;}
    .manager-job-table tr:hover td{background: #f9fafb;}

    .sonTle{font-size: 16px; color: #6A7282; height: 42px; padding-bottom: 18px;}
    .backLink{display: inline-block; cursor: pointer;}
    .job-sonM{border-radius: 10px; padding: 30px; border: 1px solid #F3F4F6; background: #fff; margin-bottom: 20px;}
    .job-sonM-t{font-size: 20px; line-height: 36px;}
    .job-sonM-subt{line-height: 28px; margin-top: 8px;}
    .job-sonM-extra{line-height: 28px; margin-top: 10px; color: #6A7282; font-size: 13px;}
    .job-son-line{padding: 0 20px; color: #99A1AF; line-height: 24px; display: inline-block;}

    .blue{color: #409EFF;}
    .red{color: #E7000B;}
    .green{color: #67C23A;}
    .yellow{color: #E6A23C;}

    .job-sonM1{border-radius: 10px; border: 1px solid #F3F4F6; background: #fff;}
    .job-son-tab{padding: 15px 10px 0 10px; height: 42px; border-bottom: 1px solid #F3F4F6; color: #3E3E3E;}
    .job-son-tab ul{margin: 0; padding: 0; list-style: none;}
    .job-son-tab ul li{height: 40px; line-height: 40px; border-bottom: 2px solid #FFF; padding: 0 16px; font-size: 14px; color: #3E3E3E; display: inline-block; cursor: pointer;}
    .job-son-tab ul li.active{border-bottom: 2px solid #E7000B; color: #E7000B;}
    .bmCheck{color: #E6A23C; text-decoration: none; background: none; border: none; font-size: 14px; cursor: pointer;}
    .bm-check{}
    .bm-check-t{line-height: 20px; font-weight: bold; padding-bottom: 12px;}
    .bm-check-m{background: #f9fafb; border: 1px solid #e9e9eb; border-radius: 10px; padding: 16px; color: #3E3E3E;}
    .manager-op-cell{
        white-space: nowrap;
        display: inline-flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 6px 14px;
    }
    .manager-op-cell .bmCheck,
    .manager-op-cell .el-button{
        margin: 0;
    }
    .manager-comment-cell{max-width: 180px;}
    .comment-preview{display: inline-block; max-width: 140px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; color: #364153; cursor: pointer; vertical-align: middle;}
    .comment-preview:hover{color: #E7000B;}
    .comment-empty{color: #99A1AF;}
    .comment-count-tag{margin-left: 6px; vertical-align: middle; cursor: pointer;}
    .comment-dialog-head{padding-bottom: 12px; color: #364153; font-size: 14px;}
    .comment-editor{background: #f9fafb; border: 1px solid #e9e9eb; border-radius: 10px; padding: 14px; margin-bottom: 16px;}
    .comment-editor-label{font-size: 13px; font-weight: bold; color: #364153; padding-bottom: 8px;}
    .comment-editor-actions{padding-top: 10px; text-align: right;}
    .comment-list-title{font-size: 14px; font-weight: bold; color: #101828; padding-bottom: 10px;}
    .user-comment-item{border: 1px solid #F3F4F6; border-radius: 8px; padding: 12px 14px; margin-bottom: 10px; background: #fff;}
    .user-comment-head{display: flex; justify-content: space-between; gap: 12px; padding-bottom: 6px;}
    .user-comment-author{font-size: 13px; font-weight: bold; color: #101828;}
    .user-comment-time{font-size: 12px; color: #99A1AF; white-space: nowrap;}
    .user-comment-content{font-size: 14px; line-height: 22px; color: #364153; white-space: pre-wrap; word-break: break-word;}
    .user-comment-actions{padding-top: 6px; text-align: right;}
    .comment-del-btn{color: #E7000B !important;}
    .delete-candidate-tip{font-size: 14px; line-height: 22px; color: #E7000B; margin-bottom: 16px;}
    .delete-candidate-info{background: #f9fafb; border: 1px solid #e9e9eb; border-radius: 8px; padding: 14px 16px; margin-bottom: 16px; font-size: 14px; line-height: 28px; color: #364153;}
    .delete-candidate-info .label{color: #6A7282;}
    .delete-candidate-confirm-label{font-size: 13px; font-weight: bold; color: #364153; margin-bottom: 8px;}
    .delete-candidate-confirm-text{font-size: 13px; line-height: 22px; color: #101828; background: #fff7ed; border: 1px dashed #f59e0b; border-radius: 6px; padding: 10px 12px; margin-bottom: 10px; word-break: break-all;}
    .status-reviewed-tag{cursor: pointer;}
    .log-empty{padding: 32px; text-align: center; color: #99A1AF;}
    .approval-log-item{
        border: 1px solid #e5e7eb;
        border-radius: 8px;
        padding: 14px 16px;
        margin-bottom: 12px;
        background: #f9fafb;
    }
    .approval-log-head{display: flex; justify-content: space-between; margin-bottom: 8px;}
    .approval-log-status{font-weight: bold; color: #101828;}
    .approval-log-time{font-size: 12px; color: #99A1AF;}
    .approval-log-row{font-size: 14px; line-height: 24px; color: #364153;}
    .approval-log-row .label{color: #6A7282;}

    /deep/ .el-dialog .el-dialog__header{background: #f9fafb !important; border-top-left-radius: 12px; border-top-right-radius: 12px;}
    /deep/ .manager-view-dialog .el-dialog__body{
        max-height: calc(100vh - 120px);
        overflow-y: auto;
        padding: 12px 20px 24px;
        background: #f3f4f6;
    }
</style>
